/**
 * Какая беседа сейчас открыта и видна человеку: туда не нужны уведомления,
 * а новые сообщения сразу считаются прочитанными.
 */
let active: { cid: string; atBottom: boolean; autoRead: boolean } | null = null;

/**
 * Беседы, которые человек сам отметил непрочитанными: открытая лента не отмечает их прочитанными обратно, пока
 * беседу не откроют заново или не отметят прочитанной явно (Esc, «Отметить прочитанным»), как в Slack.
 */
const heldUnread = new Set<string>();

export function holdUnread(cid: string): void {
  heldUnread.add(cid);
}

export function releaseUnread(cid: string): void {
  heldUnread.delete(cid);
}

export function isHeldUnread(cid: string): boolean {
  return heldUnread.has(cid);
}

/** autoRead=false — настройка «не отмечать прочитанным»: новые сообщения считаются непрочитанными. */
export function setActiveConversation(cid: string | null, atBottom = true, autoRead = true): void {
  active = cid === null ? null : { cid, atBottom, autoRead };
}

export function isViewing(cid: string): boolean {
  return active !== null && active.cid === cid && active.atBottom && document.visibilityState === 'visible' && document.hasFocus();
}

/** Человек смотрит на беседу и она сама отмечается прочитанной — новые сообщения не добавляют счётчик. */
export function readsOnView(cid: string): boolean {
  return isViewing(cid) && active?.autoRead === true && !heldUnread.has(cid);
}

